<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
// export default {
//   name: "App",
//   metaInfo: {
//     title: "",
//     meta: [
//       { charset: "utf-8" },
//       {
//         name: "viewport",
//         content: ""
//       }
//     ]
//   }
// };
export default {
  mounted(){
      if (!('placeholder' in document.createElement('input'))) {
          // 将返回的nodeList对象转为数组
          var nodes = Array.prototype.slice.call(document.querySelectorAll('[placeholder]'))
          nodes.forEach(function (item, index) {
              item.addEventListener('focus', function () {
                  this.nextSibling.style.display = 'none'
              })
              item.addEventListener('blur', function () {
                  if (!this.value) {
                      this.style.display = 'none'
                      this.nextSibling.style.display = 'inline'
                  }
              })
              var cloneNode = item.cloneNode()
              // 如果[type='password']类型，则转为text
              if (cloneNode.getAttribute('type').toLowerCase() === 'password') {
                  cloneNode.setAttribute('type', 'text')
              }
              cloneNode.setAttribute('value', cloneNode.getAttribute('placeholder'))
              cloneNode.style.display = 'none'
              item.insertAdjacentHTML('afterend', cloneNode.outerHTML)
              item.nextSibling.addEventListener('focus', function () {
                  this.style.display = 'none'
                  this.previousSibling.style.display = 'inline'
                  this.previousSibling.focus()
              })
              if (!item.value) {
                  item.style.display = 'none'
                  item.nextSibling.style.display = 'inline'
              }
          })
      }
  }
}

</script>

<style lang='scss' scoped>
#app {
  /* 重置ui样式 */
  // button
  /deep/ .el-button--primary {
    background: #4981f2;
    box-shadow: inset 0px -3px 0px 0 #3f79ee, 0px 2px 0px 0 #e5e5e5;
    &.is-disabled {
      color: #d8e3f9;
      background: #aac2f2;
      box-shadow: inset 0px -3px 0px 0 #9fb9ed, 0px 2px 0px 0 #e5e5e5;
    }
    &.is-timing {
      color: #fff;
    }
    &:hover {
      background: #1861f2;
      box-shadow: inset 0px -3px 0px 0 #3565c4, 0px 2px 0px 0 #e5e5e5;
    }
  }
  // input
  /deep/ .el-form-item__error {
    color: #f6343d;
  }
  /deep/ .el-form-item .el-input__inner {
    font-size: 16px;
    color: #333;
    border: 1px solid #ccc;
    &:focus {
      color: #333 !important;
      border-color: #4981f2;
    }
    &::-webkit-input-placeholder {
      color: #ccc;
    }
  }
  /deep/ .el-form-item.is-error .el-input__inner {
    border-color: #f6343d;
    color: #f6343d;
  }
  //自定义btn样式
  /deep/ .whiteBtn {
    &:hover {
      border: 1px solid #0051f2;
      box-shadow: inset 0px -2px 0px 0 #cccccc, 0px 2px 0px 0 #e5e5e5;
    }
    &.unAble {
      border: 1px solid #c2d2f2;
      color: #c2d2f2;
      cursor: not-allowed;
    }
  }
  /deep/ .blueBtn,
  .el-button--primary {
    &:hover {
      border-color: #1861f2;
      background: #1861f2;
      box-shadow: inset 0px -3px 0px 0 #3565c4, 0px 2px 0px 0 #e5e5e5;
    }
    &.unAble {
      border-color: #aac2f2;
      background: #aac2f2;
      box-shadow: inset 0px -3px 0px 0 #9fb9ed, 0px 2px 0px 0 #e5e5e5;
      cursor: not-allowed;
    }
  }
  /deep/ .noBind {
    color: #4d4d4d;
    background: #e3dfd7;
    box-shadow: 0px 2px 0px 0 #ddd8cf;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    &:hover {
      border-color: #1861f2;
      background: #d9cdb8;
      box-shadow: 0px 2px 0px 0 #d2c6b0;
    }
    &.unAble {
      color: #b2b0aa;
      background: #e3dfd7;
      box-shadow: 0px 2px 0px 0 #ddd8cf;
      cursor: not-allowed;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue